<span class="vector">
	@if (size() === "large") {
		<svg fill="none" height="45" viewBox="0 0 74 45" width="74" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M56.8057 0H5C2.23858 0 0 2.23858 0 5V40C0 42.7614 2.23858 45 5 45H57.1473C58.6959 45 60.1571 44.2824 61.1039 43.057L72.8893 27.8033C74.1597 26.159 74.2808 23.9003 73.1933 22.1297L61.0664 2.38336C60.1569 0.902433 58.5436 0 56.8057 0Z"
				fill="currentColor"
			/>
		</svg>
	} @else {
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="30" viewBox="0 0 40 30" fill="none">
			<path
				d="M28.8251 0H5C2.23858 0 0 2.23858 0 5V25C0 27.7614 2.23858 30 5 30H28.8251C30.6521 30 32.3336 29.0036 33.2109 27.401L38.6855 17.401C39.5045 15.9051 39.5045 14.0949 38.6855 12.599L33.2109 2.59896C32.3336 0.996439 30.6521 0 28.8251 0Z"
				fill="currentColor"
			/>
		</svg>
	}
	<span class="{{ size() }} text">{{ index() + 1 }}</span>
</span>
